import { ReachIntegration } from '@reach/interfaces/integrations/integration-type.enum';
import { QuotaStatusResponse } from '@reach/interfaces/quotas/quota.responses';
import { QuotaTypeEnum, StandardQuotaTypeEnum } from '@reach/interfaces/quotas/quota-type.enum';

import { ClientQuota } from '~ng-common-lib/quota/types/quota.type';
import { transformApiToClientQuota } from '~ng-common-lib/quota/utils/quota.utils';

import { ReachQuotaStatus, ReachQuotaStatusItem } from './quota.type';

export function quotaCalculations(
	quota: Omit<ReachQuotaStatusItem, 'percentage' | 'showWarning'>
): Pick<ReachQuotaStatusItem, 'percentage' | 'showWarning'> {
	const percentage = (quota.used / quota.total) * 100;
	const showWarning = percentage >= 90;
	return {
		percentage,
		showWarning,
	};
}

function parseStatusItem(
	data: Omit<ReachQuotaStatusItem, 'percentage' | 'showWarning'>
): ReachQuotaStatusItem {
	const total = Number(data.total);
	const available = Number(data.available);
	const used = Number(data.used);

	const item: ReachQuotaStatusItem = {
		...data,
		total,
		available,
		used,
		percentage: 0,
		showWarning: false,
	};

	const { percentage, showWarning } = quotaCalculations(item);
	item.percentage = percentage;
	item.showWarning = showWarning;

	return item;
}

export function parseResponse(response: QuotaStatusResponse): ReachQuotaStatus {
	const result = {} as ReachQuotaStatus;

	for (const key of Object.keys(response) as QuotaTypeEnum[]) {
		if (key === QuotaTypeEnum.INTEGRATION_NODES) {
			const integrationNodes = Object.keys(response[QuotaTypeEnum.INTEGRATION_NODES]).reduce<
				Record<ReachIntegration, ReachQuotaStatusItem>
			>(
				(acc, integrationKey) => {
					const integration = integrationKey as ReachIntegration;
					acc[integration] = parseStatusItem(
						response[QuotaTypeEnum.INTEGRATION_NODES][integration]
					);
					return acc;
				},
				{} as Record<ReachIntegration, ReachQuotaStatusItem>
			);
			result[QuotaTypeEnum.INTEGRATION_NODES] = integrationNodes;
		} else {
			result[key as StandardQuotaTypeEnum] = parseStatusItem(
				response[key as StandardQuotaTypeEnum]
			);
		}
	}

	return result;
}

export const commonQuotaTransformer = (appQuota: ReachQuotaStatus | null): ClientQuota | null => {
	if (!appQuota) {
		return null;
	}

	const apiQuota: QuotaStatusResponse = appQuota as unknown as QuotaStatusResponse;

	const quota: ClientQuota = transformApiToClientQuota(apiQuota);
	return quota;
};
